import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as _3 from "./auth/v1beta1/auth";
import * as _4 from "./auth/v1beta1/auth";
import * as _5 from "./auth/v1beta1/genesis";
import * as _6 from "./auth/v1beta1/query";
import * as _7 from "./base/query/v1beta1/pagination";
import * as _8 from "./base/query/v1beta1/pagination";
import * as _9 from "./base/v1beta1/coin";
import * as _10 from "./base/v1beta1/coin";
import * as _11 from "./base/abci/v1beta1/abci";
import * as _12 from "./base/kv/v1beta1/kv";
import * as _13 from "./base/node/v1beta1/query";
import * as _14 from "./base/reflection/v1beta1/reflection";
import * as _15 from "./base/reflection/v2alpha1/reflection";
import * as _16 from "./base/snapshots/v1beta1/snapshot";
import * as _17 from "./base/store/v1beta1/commit_info";
import * as _18 from "./base/store/v1beta1/listening";
import * as _19 from "./base/tendermint/v1beta1/query";
import * as _20 from "./staking/v1beta1/lsm_tx";
import * as _21 from "./staking/v1beta1/authz";
import * as _22 from "./staking/v1beta1/genesis";
import * as _23 from "./staking/v1beta1/query";
import * as _24 from "./staking/v1beta1/staking";
import * as _25 from "./staking/v1beta1/tx";
import * as _26 from "./authz/v1beta1/authz";
import * as _27 from "./authz/v1beta1/event";
import * as _28 from "./authz/v1beta1/genesis";
import * as _29 from "./authz/v1beta1/query";
import * as _30 from "./authz/v1beta1/tx";
import * as _31 from "./bank/v1beta1/authz";
import * as _32 from "./bank/v1beta1/bank";
import * as _33 from "./bank/v1beta1/genesis";
import * as _34 from "./bank/v1beta1/query";
import * as _35 from "./bank/v1beta1/tx";
import * as _36 from "./capability/v1beta1/capability";
import * as _37 from "./capability/v1beta1/genesis";
import * as _38 from "./crisis/v1beta1/genesis";
import * as _39 from "./crisis/v1beta1/tx";
import * as _40 from "./crypto/ed25519/keys";
import * as _41 from "./crypto/multisig/keys";
import * as _42 from "./crypto/secp256k1/keys";
import * as _43 from "./crypto/secp256r1/keys";
import * as _44 from "./distribution/v1beta1/distribution";
import * as _45 from "./distribution/v1beta1/genesis";
import * as _46 from "./distribution/v1beta1/query";
import * as _47 from "./distribution/v1beta1/tx";
import * as _48 from "./evidence/v1beta1/evidence";
import * as _49 from "./evidence/v1beta1/genesis";
import * as _50 from "./evidence/v1beta1/query";
import * as _51 from "./evidence/v1beta1/tx";
import * as _52 from "./feegrant/v1beta1/feegrant";
import * as _53 from "./feegrant/v1beta1/genesis";
import * as _54 from "./feegrant/v1beta1/query";
import * as _55 from "./feegrant/v1beta1/tx";
import * as _56 from "./genutil/v1beta1/genesis";
import * as _57 from "./gov/v1beta1/genesis";
import * as _58 from "./gov/v1beta1/gov";
import * as _59 from "./gov/v1beta1/query";
import * as _60 from "./gov/v1beta1/tx";
import * as _61 from "./mint/v1beta1/genesis";
import * as _62 from "./mint/v1beta1/mint";
import * as _63 from "./mint/v1beta1/query";
import * as _64 from "./params/v1beta1/params";
import * as _65 from "./params/v1beta1/query";
import * as _66 from "./slashing/v1beta1/genesis";
import * as _67 from "./slashing/v1beta1/query";
import * as _68 from "./slashing/v1beta1/slashing";
import * as _69 from "./slashing/v1beta1/tx";
import * as _70 from "./tx/signing/v1beta1/signing";
import * as _71 from "./tx/v1beta1/service";
import * as _72 from "./tx/v1beta1/tx";
import * as _73 from "./upgrade/v1beta1/query";
import * as _74 from "./upgrade/v1beta1/upgrade";
import * as _75 from "./vesting/v1beta1/tx";
import * as _76 from "./vesting/v1beta1/vesting";
import * as _150 from "./authz/v1beta1/tx.amino";
import * as _151 from "./bank/v1beta1/tx.amino";
import * as _152 from "./crisis/v1beta1/tx.amino";
import * as _153 from "./distribution/v1beta1/tx.amino";
import * as _154 from "./evidence/v1beta1/tx.amino";
import * as _155 from "./feegrant/v1beta1/tx.amino";
import * as _156 from "./gov/v1beta1/tx.amino";
import * as _157 from "./slashing/v1beta1/tx.amino";
import * as _158 from "./staking/v1beta1/tx.amino";
import * as _159 from "./vesting/v1beta1/tx.amino";
import * as _160 from "./authz/v1beta1/tx.registry";
import * as _161 from "./bank/v1beta1/tx.registry";
import * as _162 from "./crisis/v1beta1/tx.registry";
import * as _163 from "./distribution/v1beta1/tx.registry";
import * as _164 from "./evidence/v1beta1/tx.registry";
import * as _165 from "./feegrant/v1beta1/tx.registry";
import * as _166 from "./gov/v1beta1/tx.registry";
import * as _167 from "./slashing/v1beta1/tx.registry";
import * as _168 from "./staking/v1beta1/tx.registry";
import * as _169 from "./vesting/v1beta1/tx.registry";
import * as _170 from "./auth/v1beta1/query.lcd";
import * as _171 from "./authz/v1beta1/query.lcd";
import * as _172 from "./bank/v1beta1/query.lcd";
import * as _173 from "./base/node/v1beta1/query.lcd";
import * as _174 from "./base/tendermint/v1beta1/query.lcd";
import * as _175 from "./distribution/v1beta1/query.lcd";
import * as _176 from "./evidence/v1beta1/query.lcd";
import * as _177 from "./feegrant/v1beta1/query.lcd";
import * as _178 from "./gov/v1beta1/query.lcd";
import * as _179 from "./mint/v1beta1/query.lcd";
import * as _180 from "./params/v1beta1/query.lcd";
import * as _181 from "./slashing/v1beta1/query.lcd";
import * as _182 from "./staking/v1beta1/query.lcd";
import * as _183 from "./tx/v1beta1/service.lcd";
import * as _184 from "./upgrade/v1beta1/query.lcd";
import * as _185 from "./auth/v1beta1/query.rpc.query";
import * as _186 from "./authz/v1beta1/query.rpc.query";
import * as _187 from "./bank/v1beta1/query.rpc.query";
import * as _188 from "./base/node/v1beta1/query.rpc.svc";
import * as _189 from "./base/tendermint/v1beta1/query.rpc.svc";
import * as _190 from "./distribution/v1beta1/query.rpc.query";
import * as _191 from "./evidence/v1beta1/query.rpc.query";
import * as _192 from "./feegrant/v1beta1/query.rpc.query";
import * as _193 from "./gov/v1beta1/query.rpc.query";
import * as _194 from "./mint/v1beta1/query.rpc.query";
import * as _195 from "./params/v1beta1/query.rpc.query";
import * as _196 from "./slashing/v1beta1/query.rpc.query";
import * as _197 from "./staking/v1beta1/query.rpc.query";
import * as _198 from "./tx/v1beta1/service.rpc.svc";
import * as _199 from "./upgrade/v1beta1/query.rpc.query";
import * as _200 from "./authz/v1beta1/tx.rpc.msg";
import * as _201 from "./bank/v1beta1/tx.rpc.msg";
import * as _202 from "./crisis/v1beta1/tx.rpc.msg";
import * as _203 from "./distribution/v1beta1/tx.rpc.msg";
import * as _204 from "./evidence/v1beta1/tx.rpc.msg";
import * as _205 from "./feegrant/v1beta1/tx.rpc.msg";
import * as _206 from "./gov/v1beta1/tx.rpc.msg";
import * as _207 from "./slashing/v1beta1/tx.rpc.msg";
import * as _208 from "./staking/v1beta1/tx.rpc.msg";
import * as _209 from "./vesting/v1beta1/tx.rpc.msg";
import * as _235 from "./lcd";
import * as _236 from "./rpc.query";
import * as _237 from "./rpc.tx";
export let cosmos;
(function (_cosmos) {
  let auth;
  (function (_auth) {
    const v1beta1 = _auth.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _3), _4), _5), _6), _170), _185);
  })(auth || (auth = _cosmos.auth || (_cosmos.auth = {})));
  let base;
  (function (_base) {
    let query;
    (function (_query) {
      const v1beta1 = _query.v1beta1 = _objectSpread(_objectSpread({}, _7), _8);
    })(query || (query = _base.query || (_base.query = {})));
    const v1beta1 = _base.v1beta1 = _objectSpread(_objectSpread({}, _9), _10);
    let abci;
    (function (_abci) {
      const v1beta1 = _abci.v1beta1 = _objectSpread({}, _11);
    })(abci || (abci = _base.abci || (_base.abci = {})));
    let kv;
    (function (_kv) {
      const v1beta1 = _kv.v1beta1 = _objectSpread({}, _12);
    })(kv || (kv = _base.kv || (_base.kv = {})));
    let node;
    (function (_node) {
      const v1beta1 = _node.v1beta1 = _objectSpread(_objectSpread(_objectSpread({}, _13), _173), _188);
    })(node || (node = _base.node || (_base.node = {})));
    let reflection;
    (function (_reflection) {
      const v1beta1 = _reflection.v1beta1 = _objectSpread({}, _14);
      const v2alpha1 = _reflection.v2alpha1 = _objectSpread({}, _15);
    })(reflection || (reflection = _base.reflection || (_base.reflection = {})));
    let snapshots;
    (function (_snapshots) {
      const v1beta1 = _snapshots.v1beta1 = _objectSpread({}, _16);
    })(snapshots || (snapshots = _base.snapshots || (_base.snapshots = {})));
    let store;
    (function (_store) {
      const v1beta1 = _store.v1beta1 = _objectSpread(_objectSpread({}, _17), _18);
    })(store || (store = _base.store || (_base.store = {})));
    let tendermint;
    (function (_tendermint) {
      const v1beta1 = _tendermint.v1beta1 = _objectSpread(_objectSpread(_objectSpread({}, _19), _174), _189);
    })(tendermint || (tendermint = _base.tendermint || (_base.tendermint = {})));
  })(base || (base = _cosmos.base || (_cosmos.base = {})));
  let staking;
  (function (_staking) {
    const v1beta1 = _staking.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _20), _21), _22), _23), _24), _25), _158), _168), _182), _197), _208);
  })(staking || (staking = _cosmos.staking || (_cosmos.staking = {})));
  let authz;
  (function (_authz) {
    const v1beta1 = _authz.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _26), _27), _28), _29), _30), _150), _160), _171), _186), _200);
  })(authz || (authz = _cosmos.authz || (_cosmos.authz = {})));
  let bank;
  (function (_bank) {
    const v1beta1 = _bank.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _31), _32), _33), _34), _35), _151), _161), _172), _187), _201);
  })(bank || (bank = _cosmos.bank || (_cosmos.bank = {})));
  let capability;
  (function (_capability) {
    const v1beta1 = _capability.v1beta1 = _objectSpread(_objectSpread({}, _36), _37);
  })(capability || (capability = _cosmos.capability || (_cosmos.capability = {})));
  let crisis;
  (function (_crisis) {
    const v1beta1 = _crisis.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _38), _39), _152), _162), _202);
  })(crisis || (crisis = _cosmos.crisis || (_cosmos.crisis = {})));
  let crypto;
  (function (_crypto) {
    const ed25519 = _crypto.ed25519 = _objectSpread({}, _40);
    const multisig = _crypto.multisig = _objectSpread({}, _41);
    const secp256k1 = _crypto.secp256k1 = _objectSpread({}, _42);
    const secp256r1 = _crypto.secp256r1 = _objectSpread({}, _43);
  })(crypto || (crypto = _cosmos.crypto || (_cosmos.crypto = {})));
  let distribution;
  (function (_distribution) {
    const v1beta1 = _distribution.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _44), _45), _46), _47), _153), _163), _175), _190), _203);
  })(distribution || (distribution = _cosmos.distribution || (_cosmos.distribution = {})));
  let evidence;
  (function (_evidence) {
    const v1beta1 = _evidence.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _48), _49), _50), _51), _154), _164), _176), _191), _204);
  })(evidence || (evidence = _cosmos.evidence || (_cosmos.evidence = {})));
  let feegrant;
  (function (_feegrant) {
    const v1beta1 = _feegrant.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _52), _53), _54), _55), _155), _165), _177), _192), _205);
  })(feegrant || (feegrant = _cosmos.feegrant || (_cosmos.feegrant = {})));
  let genutil;
  (function (_genutil) {
    const v1beta1 = _genutil.v1beta1 = _objectSpread({}, _56);
  })(genutil || (genutil = _cosmos.genutil || (_cosmos.genutil = {})));
  let gov;
  (function (_gov) {
    const v1beta1 = _gov.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _57), _58), _59), _60), _156), _166), _178), _193), _206);
  })(gov || (gov = _cosmos.gov || (_cosmos.gov = {})));
  let mint;
  (function (_mint) {
    const v1beta1 = _mint.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _61), _62), _63), _179), _194);
  })(mint || (mint = _cosmos.mint || (_cosmos.mint = {})));
  let params;
  (function (_params) {
    const v1beta1 = _params.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _64), _65), _180), _195);
  })(params || (params = _cosmos.params || (_cosmos.params = {})));
  let slashing;
  (function (_slashing) {
    const v1beta1 = _slashing.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _66), _67), _68), _69), _157), _167), _181), _196), _207);
  })(slashing || (slashing = _cosmos.slashing || (_cosmos.slashing = {})));
  let tx;
  (function (_tx) {
    let signing;
    (function (_signing) {
      const v1beta1 = _signing.v1beta1 = _objectSpread({}, _70);
    })(signing || (signing = _tx.signing || (_tx.signing = {})));
    const v1beta1 = _tx.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _71), _72), _183), _198);
  })(tx || (tx = _cosmos.tx || (_cosmos.tx = {})));
  let upgrade;
  (function (_upgrade) {
    const v1beta1 = _upgrade.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _73), _74), _184), _199);
  })(upgrade || (upgrade = _cosmos.upgrade || (_cosmos.upgrade = {})));
  let vesting;
  (function (_vesting) {
    const v1beta1 = _vesting.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _75), _76), _159), _169), _209);
  })(vesting || (vesting = _cosmos.vesting || (_cosmos.vesting = {})));
  const ClientFactory = _cosmos.ClientFactory = _objectSpread(_objectSpread(_objectSpread({}, _235), _236), _237);
})(cosmos || (cosmos = {}));